import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsString } from '@pit/core';
import { AppVersionUpdateNeed, AppVersionUpdateType, IDtoAppVersion } from '../interfaces/dto.app.version.interface';
import { IDtoDepot } from '../interfaces/dto.depot.interface';
import { DtoDepot } from './dto.depot';
import { IDtoMandator } from '../interfaces/dto.mandator.interface';
import { DtoMandator } from './dto.mandator';

// @dynamic
@JsonObject('DtoAppVersion')
export class DtoAppVersion extends ModelEntity implements IDtoAppVersion {

    constructor(initValues: Partial<IDtoAppVersion> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('appName', String, true)
    public appName?: string = null;

    @JsonProperty('buildNumber', Number, true)
    public buildNumber?: number = null;

    @JsonProperty('majorVersion', String, true)
    public majorVersion?: string = null;

    @JsonProperty('minorVersion', String, true)
    public minorVersion?: string = null;

    @JsonProperty('updateNeed', Number, true)
    public updateNeed?: AppVersionUpdateNeed = AppVersionUpdateNeed.UpdateIsOptional;

    @JsonProperty('updateType', Number, true)
    public updateType?: AppVersionUpdateType = AppVersionUpdateType.Zip;

    @JsonProperty('version', String, true)
    public version?: string = null;

    @JsonProperty('fileDataApk', String, true)
    public fileDataApk?: string = null;

    @JsonProperty('fileDataZip', String, true)
    public fileDataZip?: string = null;

    @JsonProperty('mandator', DtoMandator, true)
    public mandator?: IDtoMandator = null;

    @JsonProperty('depots', [DtoDepot], true)
    public depots?: IDtoDepot[] = [];

}
